import React, { useState } from 'react';
import { TimingOptionEnum } from '@dev/ee-api/ee-api-models';
import { useGetSettingsInfo } from '../../../../hooks/useGetStep3Info';
import { TimingOptions } from './OptionSection';
import { TimingToggle } from './TimingToggle';

export const Timing = (): JSX.Element => {
    const { timingOption } = useGetSettingsInfo();
    const [timing, setTiming] = useState(timingOption);
    const [timingOptToggle, setTimingOptToggle] = useState(timingOption !== TimingOptionEnum.None);

    return (
        <>
            <TimingToggle
                timingOptToggle={timingOptToggle}
                setTimingOptToggle={setTimingOptToggle}
                timing={timing}
                setTiming={setTiming}
            />
            {timingOptToggle && <TimingOptions timing={timing} setTiming={setTiming} />}
        </>
    );
};
